module.exports = __webpack_public_path__ + "static/img/7434b6e7.svg";